<template>
    <v-container>
        <!--    Diálogo para Mostrar el Detalle de la Invitación Recicida    -->
        <v-dialog
                v-model="dialogDetailInvitationReceived"
                scrollable
                width="500"
        >
            <v-card align="center" color="blue-grey lighten-4" class="elevation-0">
                <v-toolbar class="mb-0" dark color="primary">
                    <v-toolbar-title>
                        {{$t('detalle_invit')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogDetailInvitationReceived = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <br>
                    <div class="text-xs-center" v-if="infoInvitationReceived">
                        <v-layout justify-center class="text-xs-center" row wrap>
                            <v-flex xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12>
                                        <v-img
                                                :src="infoInvitationReceived.principal_tutor.idFront"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12>
                                        <table id="datas">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Anfitrion')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoInvitationReceived.principal_tutor.name}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('celular')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoInvitationReceived.principal_tutor.cellNumber}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('fecha_inv')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoInvitationReceived.date}}  {{ infoInvitationReceived.time}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr v-if="infoInvitationReceived.typeInv === 1">
                                                <th>
                                                    <h2>
                                                        {{$t('fecha_expiracion')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoInvitationReceived.expiration }}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr v-if="infoInvitationReceived.typeInv === 1">
                                                <th>
                                                    <h2>
                                                        {{$t('dias_validos')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2 v-if="infoInvitationReceived.diary.includes('0') === true">
                                                        {{ $t('Lunes') }}
                                                    </h2>
                                                    <h2 v-if="infoInvitationReceived.diary.includes('1') === true">
                                                        {{ $t('Martes') }}
                                                    </h2>
                                                    <h2 v-if="infoInvitationReceived.diary.includes('2') === true">
                                                        {{ $t('Miercoles') }}
                                                    </h2>
                                                    <h2 v-if="infoInvitationReceived.diary.includes('3') === true">
                                                        {{ $t('Jueves') }}
                                                    </h2>
                                                    <h2 v-if="infoInvitationReceived.diary.includes('4') === true">
                                                        {{ $t('Viernes') }}
                                                    </h2>
                                                    <h2 v-if="infoInvitationReceived.diary.includes('5') === true">
                                                        {{ $t('Sabado') }}
                                                    </h2>
                                                    <h2 v-if="infoInvitationReceived.diary.includes('6') === true">
                                                        {{ $t('Domingo') }}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Notas')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoInvitationReceived.notes}}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                    <br>
                                <h2>{{$t('estudiante_recoger')}}</h2>
                                    <br>
                                <v-layout v-for="(student, index) in infoInvitationReceived.students" v-bind:key="index"  align-center justify-center row wrap>
                                    <v-spacer></v-spacer>
                                    <v-flex  class="text-xs-center" xs12 sm6>
                                        <div class="wrapperw">
                                            <v-img
                                                    :src="student.avatar"
                                                    position="center center"
                                                    class="grey lighten-2"
                                            ></v-img>
                                        </div>
                                    </v-flex>
                                    <v-flex  class="text-xs-center" xs12 sm6>
                                        <h3>{{student.name}}</h3>
                                    </v-flex>
                                    <v-spacer></v-spacer>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!--    Diálogo para Mostrar el Detalle de la Invitación Enviada    -->
        <v-dialog
                v-model="dialogDetailInvitationSend"
                scrollable
                width="500"
        >
            <v-card align="center" color="blue-grey lighten-4" class="elevation-0">
                <v-toolbar class="mb-0" dark color="primary">
                    <v-toolbar-title>
                        {{$t('detalle_invit')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogDetailInvitationSend = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <br>
                    <div class="text-xs-center" v-if="infoInvitationSend">
                        <v-layout justify-center class="text-xs-center" row wrap>
                            <v-flex xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12>
                                        <v-img
                                                v-if="infoInvitationSend.invited_tutor.idFront !== null"
                                                :src="infoInvitationSend.invited_tutor.idFront"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                        <v-img
                                                v-else
                                                :src="require('../../assets/na.png')"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12>
                                        <table id="datas">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Visitante')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2 v-if="infoInvitationSend.invited_tutor.name !== ' '">
                                                        {{ infoInvitationSend.invited_tutor.name}}
                                                    </h2>
                                                    <h2 v-else>
                                                        {{ $t('sin_registrar')}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('celular')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoInvitationSend.invited_tutor.cellNumber}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('fecha_inv')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoInvitationSend.date}}  {{ infoInvitationSend.time}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr v-if="infoInvitationSend.typeInv === 1">
                                                <th>
                                                    <h2>
                                                        {{$t('fecha_expiracion')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoInvitationSend.expiration }}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr v-if="infoInvitationSend.typeInv === 1">
                                                <th>
                                                    <h2>
                                                        {{$t('dias_validos')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2 v-if="infoInvitationSend.diary.includes('0') === true">
                                                        {{ $t('Lunes') }}
                                                    </h2>
                                                    <h2 v-if="infoInvitationSend.diary.includes('1') === true">
                                                        {{ $t('Martes') }}
                                                    </h2>
                                                    <h2 v-if="infoInvitationSend.diary.includes('2') === true">
                                                        {{ $t('Miercoles') }}
                                                    </h2>
                                                    <h2 v-if="infoInvitationSend.diary.includes('3') === true">
                                                        {{ $t('Jueves') }}
                                                    </h2>
                                                    <h2 v-if="infoInvitationSend.diary.includes('4') === true">
                                                        {{ $t('Viernes') }}
                                                    </h2>
                                                    <h2 v-if="infoInvitationSend.diary.includes('5') === true">
                                                        {{ $t('Sabado') }}
                                                    </h2>
                                                    <h2 v-if="infoInvitationSend.diary.includes('6') === true">
                                                        {{ $t('Domingo') }}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Notas')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoInvitationSend.notes}}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                    <br>
                                <h2>{{$t('estudiante_s')}}</h2>
                                    <br>
                                <v-layout v-for="(student, index) in infoInvitationSend.students" v-bind:key="index"  align-center justify-center row wrap>
                                    <v-spacer></v-spacer>
                                    <v-flex  class="text-xs-center" xs12 sm6>
                                        <div class="wrapperw">
                                            <v-img
                                                    :src="student.avatar"
                                                    position="center center"
                                                    class="grey lighten-2"
                                            ></v-img>
                                        </div>
                                    </v-flex>
                                    <v-flex  class="text-xs-center" xs12 sm6>
                                        <h3>{{student.name}}</h3>
                                    </v-flex>
                                    <v-spacer></v-spacer>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-card-text>
                <v-card-actions class="align-self-center">
                    <v-btn
                            color="primary"
                            large
                            :loading="loadingGafete"
                            @click="downloadGafete(infoInvitationSend)"
                    ><v-icon left>mdi-printer</v-icon>
                        {{$t('print_name_tag')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-layout calign-center >
            <v-flex>
                <v-card class="elevation-5">
                    <v-card-text>
                        <h3>{{$t('mostrando_historial_dia')}} </h3>
                        <v-form
                                @submit.prevent="submit()">
                            <v-layout class="align-center " row wrap>
                                <v-flex xs12 md6>
                                    <v-menu
                                            v-model="calendario"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y
                                            max-width="290px"
                                            min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                    v-model="computedInitialDateFormatted"
                                                    :label="$t('initialDate')"
                                                    hint="DD/MM/YYYY"
                                                    persistent-hint
                                                    prepend-icon="mdi-calendar"
                                                    name="date"
                                                    readonly
                                                    v-on="on"
                                                    :error-messages="errores.date"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                                :locale="$t('region')"
                                                v-model="date"
                                                @input="calendario = false">
                                        </v-date-picker>
                                    </v-menu>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <v-menu
                                            v-model="calendario2"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y
                                            max-width="290px"
                                            min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                    v-model="computedFinalDateFormatted"
                                                    prepend-icon="mdi-calendar"
                                                    name="date2"
                                                    :label="$t('finalDate')"
                                                    readonly
                                                    hint="DD/MM/YYYY"
                                                    persistent-hint
                                                    v-on="on"
                                                    :error-messages="errores.date2"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                                :locale="$t('region')"
                                                v-model="date2"
                                                @input="calendario2 = false">
                                        </v-date-picker>
                                    </v-menu>
                                </v-flex>
                                <br>
                                <v-flex xs6>
                                    <v-btn
                                            color="primary"
                                            type="submit"
                                            large
                                    >{{ $t('Filtrar') }}
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-form>
                        <br>
                        <v-layout calign-center v-if="getProfile.role !== 2 && getProfile.role !== 4">
                            <v-flex>
                                <v-card class="elevation-5">
                                    <v-toolbar dark color="primary">
                                        <v-toolbar-title>
                                            {{$t('Invitaciones_Recibidas')}}
                                        </v-toolbar-title>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-layout class="my-4" align-center justify-center fill-height>
                                            <v-flex >
                                                <v-data-table
                                                        :headers="headersInboxRecords"
                                                        :loading="loadingDataInboxRecords"
                                                        :items="inboxRecords"
                                                        :footer-props="{
                                                            itemsPerPageOptions: [
                                                                {text: '5', value: 5},
                                                                {text: '10', value: 10},
                                                                {text: '25', value: 25},
                                                                {text: this.$t('todos'), value: -1}
                                                            ],
                                                            itemsPerPageText: $t('filas_por_pagina')
                                                        }"
                                                        class="elevation-1"
                                                        :no-data-text="$t('no_registros')"
                                                >
                                                    <template v-slot:item.action="{ item }">
                                                        <v-icon
                                                                medium
                                                                color="grey"
                                                                class="mr-2"
                                                                @click="getInvitationInboxDetail(item)"
                                                        >
                                                            mdi-magnify
                                                        </v-icon>
                                                    </template>
<!--                                                    <template v-slot:item.accepted="{ item }">-->
<!--                                                        <v-icon-->
<!--                                                                v-if="item.accepted === true"-->
<!--                                                                medium-->
<!--                                                                color="primary"-->
<!--                                                                class="mr-2"-->
<!--                                                        >-->
<!--                                                            mdi-check-->
<!--                                                        </v-icon>-->
<!--                                                        <v-icon-->
<!--                                                                v-if="item.accepted === false"-->
<!--                                                                medium-->
<!--                                                                color="red"-->
<!--                                                                class="mr-2"-->
<!--                                                        >-->
<!--                                                            mdi-close-->
<!--                                                        </v-icon>-->
<!--                                                        {{item.accepted === true ? $t('permitida') : $t('denegada')}}-->
<!--                                                    </template>-->
                                                    <template v-slot:item.students="{ item }">
                                                        <div v-for="(student, index) in item.students" v-bind:key="index">
                                                            {{student.name}}
                                                        </div>
                                                    </template>
                                                    <template v-slot:item.date="{ item }">
                                                        {{ item.date }} {{item.time}}
                                                    </template>
                                                    <template v-slot:pageText="props">
                                                        {{props.rowsPerPage}}
                                                        {{$t('Invitaciones')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                                    </template>
                                                </v-data-table>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                        <br>
                        <v-layout calign-center v-if="getProfile.role !== 2 && getProfile.role !== 4">
                            <v-flex>
                                <v-card class="elevation-5">
                                    <v-toolbar dark color="primary">
                                        <v-toolbar-title>
                                            {{$t('Invitaciones_Enviadas')}}
                                        </v-toolbar-title>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-layout class="my-4" align-center justify-center fill-height>
                                            <v-flex >
                                                <v-data-table
                                                        :headers="headersSentRecords"
                                                        :loading="loadingDataSentRecords"
                                                        :items="SentRecords"
                                                        :footer-props="{
                                                            itemsPerPageOptions: [
                                                                {text: '5', value: 5},
                                                                {text: '10', value: 10},
                                                                {text: '25', value: 25},
                                                                {text: this.$t('todos'), value: -1}
                                                            ],
                                                            itemsPerPageText: $t('filas_por_pagina')
                                                        }"
                                                        class="elevation-1"
                                                        :no-data-text="$t('no_registros')"
                                                >
                                                    <template v-slot:item.action="{ item }">
                                                        <v-icon
                                                                medium
                                                                color="grey"
                                                                class="mr-2"
                                                                @click="getInvitationSentDetail(item)"
                                                        >
                                                            mdi-magnify
                                                        </v-icon>
                                                    </template>
<!--                                                    <template v-slot:item.accepted="{ item }">-->
<!--                                                        <v-icon-->
<!--                                                                v-if="item.accepted === true"-->
<!--                                                                medium-->
<!--                                                                color="primary"-->
<!--                                                                class="mr-2"-->
<!--                                                        >-->
<!--                                                            mdi-check-->
<!--                                                        </v-icon>-->
<!--                                                        <v-icon-->
<!--                                                                v-if="item.accepted === false"-->
<!--                                                                medium-->
<!--                                                                color="red"-->
<!--                                                                class="mr-2"-->
<!--                                                        >-->
<!--                                                            mdi-close-->
<!--                                                        </v-icon>-->
<!--                                                        {{item.accepted === true ? $t('permitida') : $t('denegada')}}-->
<!--                                                    </template>-->
                                                    <template v-slot:item.date="{ item }">
                                                        {{ item.date }} {{item.time}}
                                                    </template>
                                                    <template v-slot:item.invited_tutor.name="{ item }">
                                                        {{item.invited_tutor.name === ' ' ? $t('sin_registrar') : item.invited_tutor.name}}
                                                    </template>
                                                    <template v-slot:item.students="{ item }">
                                                        <div v-for="(student, index) in item.students" v-bind:key="index">
                                                            {{student.name}}
                                                        </div>
                                                    </template>
                                                    <template v-slot:pageText="props">
                                                        {{props.rowsPerPage}}
                                                        {{$t('Invitaciones')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                                    </template>
                                                </v-data-table>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                        <br>
                        <v-layout calign-center v-show="getProfile.role === 4">
                            <v-flex>
                                <v-card class="elevation-5">
                                    <v-toolbar dark color="primary">
                                        <v-toolbar-title>
                                            {{$t('attendance_list')}}
                                        </v-toolbar-title>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-layout class="my-4" align-center justify-center fill-height>
                                          <v-flex>
                                            <v-card-title>
                                              <v-layout row wrap>
                                                <v-flex xs12 sm4>
                                                  <v-autocomplete
                                                      class="mt-1 mb-1 ml-1 mr-1"
                                                      v-model="classroom"
                                                      outlined
                                                      :placeholder="$t('classrooms')"
                                                      prepend-inner-icon="mdi-google-classroom"
                                                      name="classroom"
                                                      item-text="name"
                                                      item-value="fullname"
                                                      :label="$t('classroom')"
                                                      :items="classrooms"
                                                      no-data-text="Ningún Resultado"
                                                      clearable
                                                  >
                                                    <template v-slot:selection="data">
                                                      <v-chip
                                                          v-bind="data.attrs"
                                                          :input-value="data.selected"
                                                          @click="data.select"
                                                      >
                                                        {{ data.item.fullname }}
                                                      </v-chip>
                                                    </template>
                                                    <template v-slot:item="data">
                                                      <template v-if="typeof data.item !== 'object'">
                                                        <v-list-item-content v-text="data.item"></v-list-item-content>
                                                      </template>
                                                      <template v-else>
                                                        <v-list-item-content>
                                                          <v-list-item-title v-html="data.item.fullname"></v-list-item-title>
                                                        </v-list-item-content>
                                                      </template>
                                                    </template>
                                                  </v-autocomplete>
                                                </v-flex>
                                                <v-flex xs12 sm8>
                                                  <v-text-field
                                                      class="mt-1 mb-1 ml-1 mr-1"
                                                      outlined
                                                      clearable
                                                      v-model="searchStundets"
                                                      append-icon="mdi-magnify"
                                                      :label="$t('Buscar')"
                                                      :placeholder="$t('placeholder_invitados2')"
                                                      single-line
                                                      hide-details
                                                  ></v-text-field>
                                                </v-flex>
                                              </v-layout>
                                            </v-card-title>
                                            <v-btn
                                                v-show="attendanceRecords.length > 0"
                                                color="primary"
                                                @click="exportPdfHealthFormat"
                                            >
                                              {{$t('export_to_pdf')}}
                                            </v-btn>
                                            <v-data-table
                                                :headers="headersAttendanceRecords"
                                                :loading="loadingDataAttendanceRecords"
                                                :items="attendanceRecords"
                                                :search="searchStundets"
                                                multi-sort
                                                @current-items="getFiltered"
                                                :footer-props="{
                                                            itemsPerPageOptions: [
                                                                {text: this.$t('todos'), value: -1}
                                                            ],
                                                            itemsPerPageText: $t('filas_por_pagina')
                                                        }"
                                                class="elevation-1"
                                                :no-data-text="$t('no_registros')"
                                            >
                                              <template v-slot:item.temperature="{ item }">
                                                {{item.temperature === ''|| item.temperature === null ? $t('sin_registrar') : item.temperature}}
                                              </template>
                                              <template v-slot:pageText="props">
                                                {{props.rowsPerPage}}
                                                {{$t('Invitaciones')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                              </template>
                                              <template v-slot:no-results>
                                                <v-alert type="warning">
                                                  {{$t('ningun_resultado_1')}} "{{ searchStundets }}" {{$t('ningun_resultado_2')}}
                                                </v-alert>
                                              </template>
                                            </v-data-table>
                                          </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                        <br>
                        <v-layout calign-center v-show="getProfile.role !== 1 && getProfile.express_check_out === false">
                            <v-flex>
                                <v-card class="elevation-5">
                                    <v-toolbar dark color="primary">
                                        <v-toolbar-title>
                                            {{$t('Registros_Salidas')}}
                                        </v-toolbar-title>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-layout class="my-4" align-center justify-center fill-height>
                                            <v-flex>
                                              <v-card-title>
                                                <v-layout row wrap>
                                                  <v-flex xs12>
                                                    <v-text-field
                                                        class="mt-1 mb-1 ml-1 mr-1"
                                                        outlined
                                                        clearable
                                                        v-model="searchCheckOut"
                                                        append-icon="mdi-magnify"
                                                        :label="$t('Buscar')"
                                                        :placeholder="$t('placeholder_invitados2')"
                                                        single-line
                                                        hide-details
                                                    ></v-text-field>
                                                  </v-flex>
                                                </v-layout>
                                              </v-card-title>
                                              <v-data-table
                                                        :headers="headersCheckOutRecords"
                                                        :loading="loadingDataCheckOutRecords"
                                                        :items="checkOutRecords"
                                                        :search="searchCheckOut"
                                                        :footer-props="{
                                                            itemsPerPageOptions: [
                                                                {text: '5', value: 5},
                                                                {text: '10', value: 10},
                                                                {text: '25', value: 25},
                                                                {text: this.$t('todos'), value: -1}
                                                            ],
                                                            itemsPerPageText: $t('filas_por_pagina')
                                                        }"
                                                        class="elevation-1"
                                                        :no-data-text="$t('no_registros')"
                                                >
<!--                                                    <template v-slot:item.action="{ item }">-->
<!--                                                        <v-icon-->
<!--                                                                medium-->
<!--                                                                color="grey"-->
<!--                                                                class="mr-2"-->
<!--                                                                @click="get_detail(item.id)"-->
<!--                                                        >-->
<!--                                                            mdi-magnify-->
<!--                                                        </v-icon>-->
<!--                                                    </template>-->
                                                    <template v-slot:item.accepted="{ item }">
                                                        <v-icon
                                                                v-if="item.accepted === true"
                                                                medium
                                                                color="primary"
                                                                class="mr-2"
                                                        >
                                                            mdi-check
                                                        </v-icon>
                                                        <v-icon
                                                                v-if="item.accepted === false"
                                                                medium
                                                                color="red"
                                                                class="mr-2"
                                                        >
                                                            mdi-close
                                                        </v-icon>
                                                        {{item.accepted === true ? $t('permitida') : $t('denegada')}}
                                                    </template>
                                                    <template v-slot:item.date="{ item }">
                                                        {{ item.date }} {{item.time}}
                                                    </template>
                                                    <template v-slot:pageText="props">
                                                        {{props.rowsPerPage}}
                                                        {{$t('Invitaciones')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                                    </template>
                                                    <template v-slot:no-results>
                                                      <v-alert type="warning">
                                                        {{$t('ningun_resultado_1')}} "{{ searchCheckOut }}" {{$t('ningun_resultado_2')}}
                                                      </v-alert>
                                                    </template>
                                                </v-data-table>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                        <v-layout calign-center v-show="getProfile.role !== 1 && getProfile.express_check_out === true">
                            <v-flex>
                                <v-card class="elevation-5">
                                    <v-toolbar dark color="primary">
                                        <v-toolbar-title>
                                            {{$t('Registros_Salidas')}}
                                        </v-toolbar-title>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-layout class="my-4" align-center justify-center fill-height>
                                            <v-flex >
                                                <v-data-table
                                                        :headers="headersCheckOutExpressRecords"
                                                        :loading="loadingDataCheckOutExpressRecords"
                                                        :items="checkOutExpressRecords"
                                                        :footer-props="{
                                                            itemsPerPageOptions: [
                                                                {text: '5', value: 5},
                                                                {text: '10', value: 10},
                                                                {text: '25', value: 25},
                                                                {text: this.$t('todos'), value: -1}
                                                            ],
                                                            itemsPerPageText: $t('filas_por_pagina')
                                                        }"
                                                        class="elevation-1"
                                                        :no-data-text="$t('no_registros')"
                                                >
                                                    <template v-slot:item.date="{ item }">
                                                        {{ item.date }} {{item.time}}
                                                    </template>
                                                    <template v-slot:pageText="props">
                                                        {{props.rowsPerPage}}
                                                        {{$t('Invitaciones')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                                    </template>
                                                </v-data-table>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import {HTTP} from '@/main.js'
import JSPDF from 'jspdf'
import store from '@/store'
import { mapGetters } from 'vuex'
import jsPDF from 'jspdf'
import 'jspdf-autotable'

export default {
  name: "historical",
  data: () => ({
    calendario: '',
    date: '',
    calendario2: '',
    date2: '',
    errores: [],
    fecha_actual: '',
    yyyy: '',
    mm: '',
    dd: '',
    yyyy2: '',
    mm2: '',
    dd2: '',
    headersCheckOutRecords: [],
    headersCheckOutExpressRecords: [],
    headersInboxRecords: [],
    headersSentRecords: [],
    loadingDataCheckOutRecords: false,
    loadingDataCheckOutExpressRecords: false,
    loadingDataInboxRecords: false,
    loadingDataSentRecords: false,
    checkOutRecords: [],
    checkOutExpressRecords: [],
    inboxRecords: [],
    SentRecords: [],
    dialogDetailInvitationReceived: false,
    infoInvitationReceived: '',
    dialogDetailInvitationSend: false,
    infoInvitationSend: '',
    loadingGafete: false,
    classrooms: [],
    aux: [],
    headersAttendanceRecords: [],
    loadingDataAttendanceRecords: false,
    attendanceRecords: [],
    searchStundets: '',
    searchCheckOut: '',
    classroom: null,
  }),
  created () {
    this.fecha_actual = this.get_current_date()
    this.date = this.fecha_actual
    this.date2 = this.fecha_actual
    this.getClassrooms()
    this.getAttendanceRecords(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
    this.getCheckOutRecords(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
    this.getCheckOutExpressRecords(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
    this.getInboxRecords(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
    this.getSentRecords(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
  },
  beforeUpdate () {
    this.headersAttendanceRecords = [
      {
        text: this.$t('estudiante'),
        align: 'center',
        sortable: true,
        value: 'fullname_student'
      },
      {
        text: this.$t('classroom'),
        align: 'center',
        sortable: true,
        value: 'classroom',
        filter: this.classroomFilter
      },
      {
        text: this.$t('date'),
        align: 'center',
        sortable: true,
        value: 'date_time'
      },
      {
        text: this.$t('temperature'),
        align: 'center',
        sortable: true,
        value: 'temperature'
      }
    ]
    this.headersInboxRecords = [
      {
        text: this.$t('acciones'),
        align: 'center',
        value: 'action',
        sortable: false
      },
      {
        text: this.$t('fecha_hora'),
        align: 'center',
        sortable: true,
        value: 'date'
      },
      {
        text: this.$t('Anfitrion'),
        align: 'center',
        sortable: true,
        value: 'principal_tutor.name'
      },
      {
        text: this.$t('celular'),
        align: 'center',
        sortable: true,
        value: 'principal_tutor.cellNumber'
      },
      {
        text: this.$t('estudiante_s'),
        align: 'center',
        sortable: true,
        value: 'students'
      },
      {
        text: this.$t('Notas'),
        align: 'center',
        sortable: true,
        value: 'notes'
      }
    ]
    this.headersSentRecords = [
      {
        text: this.$t('acciones'),
        align: 'center',
        value: 'action',
        sortable: false
      },
      {
        text: this.$t('fecha_hora'),
        align: 'center',
        sortable: true,
        value: 'date'
      },
      {
        text: this.$t('Visitante'),
        align: 'center',
        sortable: true,
        value: 'invited_tutor.name'
      },
      {
        text: this.$t('celular'),
        align: 'center',
        sortable: true,
        value: 'invited_tutor.cellNumber'
      },
      {
        text: this.$t('estudiante_s'),
        align: 'center',
        sortable: true,
        value: 'students'
      },
      {
        text: this.$t('Notas'),
        align: 'center',
        sortable: true,
        value: 'notes'
      }
    ]
    this.headersCheckOutRecords = [
      // {
      //     text: this.$t('acciones'),
      //     align: 'center',
      //     value: 'action',
      //     sortable: false
      // },
      {
        text: this.$t('estudiante'),
        align: 'center',
        sortable: true,
        value: 'student'
      },
      {
        text: 'Tutor',
        align: 'center',
        sortable: true,
        value: 'tutor'
      },
      {
        text: this.$t('Vigilante'),
        align: 'center',
        sortable: true,
        value: 'vigilant'
      },
      {
        text: this.$t('fecha_salida'),
        align: 'center',
        sortable: true,
        value: 'date'
      },
      {
        text: this.$t('estado'),
        align: 'center',
        sortable: true,
        value: 'accepted'
      },
      // {
      //   text: this.$t('Notas'),
      //   align: 'center',
      //   sortable: true,
      //   value: 'notes'
      // }
    ]
    this.headersCheckOutExpressRecords = [
      {
        text: this.$t('estudiante'),
        align: 'center',
        sortable: true,
        value: 'student'
      },
      {
        text: this.$t('nombre'),
        align: 'center',
        sortable: true,
        value: 'user'
      },
      {
        text: this.$t('fecha_salida'),
        align: 'center',
        sortable: true,
        value: 'date'
      }
    ]
  },
  computed: {
    ...mapGetters(['getProfile']),
    computedInitialDateFormatted () {
      return this.formatDate(this.date)
    },
    computedFinalDateFormatted () {
      return this.formatDate(this.date2)
    }
  },
  methods: {
    getFiltered(e){
      // console.log(e) //output the filtered items
      this.aux = e
    },
    get_current_date () {
      var today = new Date()
      this.dd = today.getDate()
      this.mm = today.getMonth() + 1
      this.yyyy = today.getFullYear()
      this.dd2 = today.getDate()
      this.mm2 = today.getMonth() + 1
      this.yyyy2 = today.getFullYear()

      if (this.dd < 10) {
        this.dd = '0' + this.dd
      }
      if (this.dd2 < 10) {
        this.dd2 = '0' + this.dd2
      }
      if (this.mm < 10) {
        this.mm = '0' + this.mm
      }
      if (this.mm2 < 10) {
        this.mm2 = '0' + this.mm2
      }
      today = this.yyyy + '-' + this.mm + '-' + this.dd
      return today
    },
    getClassrooms () {
      HTTP.get('classroom/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        this.classrooms = response.data
        if (this.classrooms.length > 0){
          for (let i = 0; i < this.classrooms.length; i++) {
            console.log(this.classrooms[i].grade_name + ' '+ this.classrooms[i].name)
            this.classrooms[i].fullname = this.classrooms[i].grade_name + ' '+ this.classrooms[i].name
          }
          // console.log('Hola')
          console.log(this.classrooms)
        }
      })
      .catch(e => {
        console.log(e)
      })
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    getAttendanceRecords (yyyy, mm, dd, yyyy2, mm2, dd2) {
      console.log(yyyy, mm, dd, '-', yyyy2, mm2, dd2)
      this.loadingDataAttendanceRecords = true
      HTTP.get('student/list/' + yyyy + '/' + mm + '/' + dd + '/' + yyyy2 + '/' + mm2 + '/' + dd2 + '/', {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        console.log(response)
        if (response.status === 204) {
          this.attendanceRecords = []
        } else {
          this.attendanceRecords  = response.data
        }
        this.loadingDataAttendanceRecords = false
      })
      .catch(error => {
        this.loadingDataAttendanceRecords = false
        console.log(error)
      })
    },
    getInboxRecords (yyyy, mm, dd, yyyy2, mm2, dd2) {
      console.log(yyyy, mm, dd, '-', yyyy2, mm2, dd2)
      this.loadingDataInboxRecords = true
      HTTP.get('invitation/received/' + yyyy + '/' + mm + '/' + dd + '/' + yyyy2 + '/' + mm2 + '/' + dd2 + '/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        console.log(response)
        if (response.status === 204) {
          this.inboxRecords = []
        } else {
          this.inboxRecords  = response.data
        }
        this.loadingDataInboxRecords = false
      })
      .catch(error => {
        this.loadingDataInboxRecords = false
        console.log(error)
      })
    },
    getCheckOutRecords (yyyy, mm, dd, yyyy2, mm2, dd2) {
      console.log(yyyy, mm, dd, '-', yyyy2, mm2, dd2)
      this.loadingDataCheckOutRecords = true
      HTTP.get('exit/' + yyyy + '/' + mm + '/' + dd + '/' + yyyy2 + '/' + mm2 + '/' + dd2 + '/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        console.log('Respuesta')
        console.log(response)
        if (response.status === 204) {
          this.checkOutRecords = []
        } else {
          this.checkOutRecords = response.data
        }
        this.loadingDataCheckOutRecords = false
      })
      .catch(error => {
        this.loadingDataCheckOutRecords = false
        console.log(error)
      })
    },
    getCheckOutExpressRecords (yyyy, mm, dd, yyyy2, mm2, dd2) {
      console.log(yyyy, mm, dd, '-', yyyy2, mm2, dd2)
      this.loadingDataCheckOutExpressRecords = true
      HTTP.get('express_exit/' + yyyy + '/' + mm + '/' + dd + '/' + yyyy2 + '/' + mm2 + '/' + dd2 + '/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        console.log('Respuesta')
        console.log(response)
        if (response.status === 204) {
          this.checkOutExpressRecords = []
        } else {
          this.checkOutExpressRecords = response.data
        }
        this.loadingDataCheckOutExpressRecords = false
      })
      .catch(error => {
        this.loadingDataCheckOutExpressRecords = false
        console.log(error)
      })
    },
    getSentRecords (yyyy, mm, dd, yyyy2, mm2, dd2) {
      console.log(yyyy, mm, dd, '-', yyyy2, mm2, dd2)
      this.loadingDataSentRecords = true
      HTTP.get('invitation/send/' + yyyy + '/' + mm + '/' + dd + '/' + yyyy2 + '/' + mm2 + '/' + dd2 + '/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        console.log('Respuesta')
        console.log(response)
        if (response.status === 204) {
          this.SentRecords = []
        } else {
          this.SentRecords  = response.data
        }
        this.loadingDataSentRecords = false
      })
      .catch(error => {
        this.loadingDataSentRecords = false
        console.log(error)
      })
    },
    getInvitationInboxDetail (item) {
      this.infoInvitationReceived = item
      this.dialogDetailInvitationReceived = true
      console.log(this.infoInvitationReceived)
    },
    getInvitationSentDetail (item) {
      this.infoInvitationSend = item
      this.dialogDetailInvitationSend = true
      console.log(this.infoInvitationSend)
    },
    split_date (date, date2) {
      var arr = date.split('-')
      var arr2 = date2.split('-')

      this.yyyy = arr[0]
      this.mm = arr[1]
      this.dd = arr[2]

      this.yyyy2 = arr2[0]
      this.mm2 = arr2[1]
      this.dd2 = arr2[2]
    },
    submit () {
      this.split_date(this.date, this.date2)
      this.getAttendanceRecords(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
      this.getCheckOutRecords(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
      this.getCheckOutExpressRecords(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
      this.getInboxRecords(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
      this.getSentRecords(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
    },
    xOffset (pdf, text) {
      return (
          pdf.internal.pageSize.width / 2) - (pdf.getStringUnitWidth(text) * pdf.internal.getFontSize() / 2)
    },
    getImgFromUrl (logoUrl, callback) {
      var img = new Image()

      img.src = logoUrl
      img.onload = function () {
        callback(img)
      }
    },
    classroomFilter (value) {
      // If this filter has no value we just skip the entire filter.
      if (this.classroom === null || this.classroom === undefined) {
        return true
      }
      // Check if the current loop value (The calories value)
      // equals to the selected value at the <v-select>.
      return value.toLowerCase().includes(this.classroom.toLowerCase())
    },
    exportPdfHealthFormat () {
      var fechaInicial = this.formatDate(this.date)
      var fechaFinal = this.formatDate(this.date2)
      var headerInvitationSent = this.$t('headerAttendanceReport')
      var period = this.$t('period')
      var al = this.$t('al')
      var page = this.$t('page')
      var de = this.$t('de')
      var temperature = this.$t('sin_registrar')
      // var headerDate = this.$t('fecha_hora')
      var columns = [{
        fullname_student: this.$t('estudiante'),
        classroom: this.$t('classroom'),
        date_time: this.$t('date'),
        temperature: this.$t('temperature'),
      }]
      var doc = new jsPDF("portrait", "pt", "letter")
      var totalPagesExp = '{total_pages_count_string}'
      doc.autoTable({
        head: columns,
        body: this.aux,
        didDrawPage: function (data) {
          // Header
          doc.setFontSize(20)
          doc.setTextColor(40)
          doc.setFontStyle('normal')
          // if (base64Img) {
          //     doc.addImage(base64Img, 'JPEG', data.settings.margin.left, 15, 10, 10)
          // }
          doc.text(headerInvitationSent, data.settings.margin.left + 20, 38)
          doc.text(period + fechaInicial + al + fechaFinal, data.settings.margin.left + 20, 60)

          // Footer
          var str = page + doc.internal.getNumberOfPages()
          // Total page number plugin only available in jspdf v1.0+
          if (typeof doc.putTotalPages === 'function') {
            str = str + de + totalPagesExp
          }
          doc.setFontSize(10)

          // jsPDF 1.4+ uses getWidth, <1.4 uses .width
          var pageSize = doc.internal.pageSize
          var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
          doc.text(str, data.settings.margin.left, pageHeight - 10)
        },
        allSectionHooks: true,
        didParseCell: function (data) {
          if (data.row.section === 'body') {
            if (data.column.index === 3) {
              if(data.cell.text.toString() === '' || data.cell.text.toString() === ' ' || data.cell.text.toString() === null){
                data.cell.text = temperature
              }
            }
          }
        },
        margin: { top: 80 }
      })
      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === 'function') {
        doc.putTotalPages(totalPagesExp)
      }
      doc.save('attendance_report' + '_' + this.date + '_' + this.date2 + '.pdf')
    },
    downloadGafete (infoInvitationSend) {
      this.loadingGafete = true
      console.log('Datos de la Invitación: ')
      console.log(infoInvitationSend)
      // console.log(infoInvitationSend)
      const toDataUrl2 = (url, callback) => {
        HTTP.get(url, { responseType:"blob" })
        .then(function (response) {
          const reader = new window.FileReader()
          reader.readAsDataURL(response.data)
          reader.onload = () => {
            callback(reader.result)
          }
        })
      }
      toDataUrl2('https://api.qrserver.com/v1/create-qr-code/?data=' + infoInvitationSend.qr_code + '&ecc=M&margin=20&size=400x400', (qrCodeImage) => {
        var pdf = new JSPDF('portrait', 'pt', 'letter')
        // Black square with rounded corners
        pdf.setDrawColor(0)
        pdf.setFillColor(255, 255, 255)
        pdf.roundedRect(180, 50, 250, 400, 5, 5, 'FD')
        // pdf.setFontStyle('bold')
        // pdf.text(infoInvitationSend.housing_unit_name,
        //   this.xOffset(pdf, infoInvitationSend.housing_unit_name),
        //   100)
        pdf.setFontStyle('normal')
        pdf.setFontSize(16)
        pdf.text(this.$t('Visitante'),
            this.xOffset(pdf, this.$t('Visitante')),
            115)
        pdf.setFontStyle('bold')
        pdf.setFontSize(13)
        pdf.text(infoInvitationSend.invited_tutor.name,
            this.xOffset(pdf, infoInvitationSend.invited_tutor.name),
            130)
        pdf.setFontStyle('normal')
        pdf.setFontSize(16)
        pdf.text('Tutor',
            this.xOffset(pdf, 'Tutor'),
            145)
        pdf.setFontStyle('bold')
        pdf.setFontSize(13)
        pdf.text(infoInvitationSend.principal_tutor.name,
            this.xOffset(pdf, infoInvitationSend.principal_tutor.name),
            160)
        // pdf.setFontStyle('normal')
        // pdf.setFontSize(16)
        // pdf.text(this.$t('numero_casa'),
        //     this.xOffset(pdf, this.$t('numero_casa')),
        //     175)
        // pdf.setTextColor('#000000')
        // pdf.setFontStyle('bold')
        // pdf.setFontSize(13)
        // pdf.text(infoInvitationSend.house_address,
        //     this.xOffset(pdf, infoInvitationSend.house_address),
        //     190)
        pdf.setTextColor('#000000')
        pdf.setFontStyle('normal')
        pdf.setFontSize(16)
        pdf.text(this.$t('fecha_hora'),
            this.xOffset(pdf, this.$t('fecha_hora')),
            205)
        pdf.setFontStyle('bold')
        pdf.setFontSize(13)
        pdf.text(infoInvitationSend.date + ' ' + infoInvitationSend.time,
            this.xOffset(pdf, infoInvitationSend.date + ' ' + infoInvitationSend.time),
            220)
        // pdf.setTextColor('#000000')
        // pdf.setFontStyle('normal')
        // pdf.setFontSize(16)
        // pdf.text(this.$t('fecha_expiracion'),
        //     this.xOffset(pdf, this.$t('fecha_expiracion')),
        //     235)
        // pdf.setFontStyle('bold')
        // pdf.setFontSize(13)
        // pdf.text(infoInvitationSend.expiration,
        //     this.xOffset(pdf, infoInvitationSend.expiration),
        //     250)
        pdf.setFontSize(6)
        pdf.setFontStyle('normal')
        pdf.text('El único objetivo del presente gafete es la de validar el acceso del portador',
            this.xOffset(pdf, 'El único objetivo del presente gafete es la de validar el acceso del portador'),
            410)
        pdf.text('mediante las reglas de operación del sistema Intrare Escuela. No existe',
            this.xOffset(pdf, 'mediante las reglas de operación del sistema Intrare Escuela. No existe'),
            418)
        pdf.text('relación laboral alguna entre el portador de este gafete ni con la empresa',
            this.xOffset(pdf, 'relación laboral alguna entre el portador de este gafete ni con la empresa'),
            426)
        pdf.text('Intrare Escuela ni con el Escuela.',
            this.xOffset(pdf, 'Intrare Escuela ni con el Escuela.'),
            434)
        // pdf.setLineWidth(4.0)
        // pdf.setDrawColor('#0000FF')
        // pdf.setFillColor('#FFFFFF')
        // pdf.roundedRect(212, 257, 186, 186, 5, 5, 'FD')
        // console.log(qrCodeImage); // qrCodeImage is the base64 string
        pdf.addImage(qrCodeImage, 'WEBP', 230, 254, 150, 150)
        toDataUrl2(this.getProfile.logo, (logoGuest) => {
          pdf.addImage(logoGuest, 'WEBP', 190, 60, 50, 50)
          this.getImgFromUrl(require('../../assets/logo_escuela.png'), function (logoSystem) {
            pdf.addImage(logoSystem, 'WEBP', 370, 60, 50, 50)
            pdf.save('gafete.pdf')
          })
        })
        this.loadingGafete = false
      })
    }
  }
}
</script>

<style scoped>
    #datas {
        font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
        border-collapse: collapse;
        width: 100%;
    }

    #datas td, #datas th {
        padding: 8px;
    }

    #datas tr:nth-child(even){background-color: #f2f2f2;}

    #datas tr:hover {background-color: #ddd;}

    #datas th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: #00A1E4;
        color: white;
    }
    .edge {
        border-radius: 8px;
        border-color: #00A1E4 #00A1E4 #00A1E4 #00A1E4;
        border-width: 3px 3px 3px 3px;
        border-style: solid solid solid solid;
    }
    .wrapperw{
        width:200px;
        height:200px;
        position: relative;
        margin: 25px auto;
        overflow: hidden;
        border-radius:50%;
        border: 5px solid #00A1E4;
    }
    .wrapperw img{
        position: relative;
        width:100%;
        height:auto;
    }
</style>
